import React from 'react';
import cn from 'classnames';
import type { DividerProps } from './types';
import './style.scss';

export const Divider: React.FC<DividerProps> = ({ type = 'horizontal', className }) => (
  <div className={cn('divider-default', type, className)} />
);
